<template>
    <div class="row">
        <div class="position-relative w-100">
            <div class="w-100 d-flex justify-content-between align-items-center">
                <h4 class="py-3">Patients</h4>
                <a
                    class="btn btn-sm font-weight-bold text-white text-uppercase"
                    :class="canAddClient ? 'btn-primary' : 'btn-light cursor-not-allowed'"
                    @click="canAddClient ? showAddNewModal() : null"
                    >Add new patient</a
                >
            </div>
            <tabs :filter="filter" :tabs="tabs" @set-parent-prop="updateFilter($event)"></tabs>

            <div class="my-3 px-3 form-group row">
                <input
                    type="text"
                    class="form-control form-control-sm col-8 col-sm-4"
                    v-model="search"
                    placeholder="Search by First or Last Name"
                />
                <button
                    class="btn btn-sm btn-primary font-weight-bold text-uppercase mx-3"
                    @click="fetchOrganizationClients()"
                >
                    Search
                </button>
            </div>

            <paginator
                :pagination="pagination"
                @fetch="fetchOrganizationClients($event)"
            ></paginator>

            <div class="mb-3">
                <div class="row">
                    <div class="col-12">
                        <div class="row mx-0 px-2" style="background-color: #323336">
                            <div class="col-4 px-1">
                                <small class="text-uppercase text-white">Client Name</small>
                            </div>
                            <div class="col-4 px-1">
                                <small class="text-uppercase text-white">Parent E-mail</small>
                            </div>
                            <div class="col-4 px-1">
                                <small class="text-uppercase text-white">Date of Birth</small>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mx-0">
                    <div class="col-12">
                        <div
                            v-for="c in organizationClients"
                            class="row p-2 list-item bg-white"
                            :class=""
                        >
                            <div class="px-1 col-4">
                                <a
                                    class="text-primary cursor-pointer"
                                    :href="`/patients/${c.id}/details`"
                                    >{{ c.name }}</a
                                >
                            </div>
                            <div class="px-1 col-4">
                                <span>{{ c.parent_email }}</span>
                            </div>
                            <div
                                class="px-1 col-4 d-flex justify-content-between align-items-center"
                            >
                                <span>{{ c.dob ? moment(c.dob).format("MM/DD/YYYY") : "" }}</span>
                                <button
                                    class="btn btn-sm btn-link text-black"
                                    type="button"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                    :id="`archive-${c.user ? c.user.id : c.id}`"
                                >
                                    <i class="fa fa-ellipsis-v"></i>
                                </button>
                                <div
                                    v-if="!filter"
                                    class="dropdown-menu dropdown-menu-right"
                                    aria-labelledby="patient-actions"
                                >
                                    <a
                                        :class="
                                            canAddClient
                                                ? 'text-danger cursor-pointer'
                                                : 'text-light cursor-not-allowed'
                                        "
                                        class="dropdown-item small actions"
                                        :id="`confirm-waitlist-${c.user ? c.user.id : c.id}`"
                                        @click="
                                            canAddClient ? handleClientUpdate(c, 'Waitlist') : null
                                        "
                                    >
                                        Waitlist patient
                                    </a>
                                    <a
                                        :class="
                                            canAddClient
                                                ? 'text-danger cursor-pointer'
                                                : 'text-light cursor-not-allowed'
                                        "
                                        class="dropdown-item small actions"
                                        :id="`confirm-archive-${c.user ? c.user.id : c.id}`"
                                        @click="
                                            canAddClient ? handleClientUpdate(c, 'Archive') : null
                                        "
                                    >
                                        Archive patient
                                    </a>
                                </div>
                                <div
                                    v-else
                                    class="dropdown-menu dropdown-menu-right"
                                    aria-labelledby="patient-actions"
                                >
                                    <a
                                        :class="
                                            canAddClient
                                                ? 'text-danger cursor-pointer'
                                                : 'text-light cursor-not-allowed'
                                        "
                                        class="dropdown-item small actions"
                                        :id="`confirm-unarchive-${c.user ? c.user.id : c.id}`"
                                        @click="
                                            canAddClient
                                                ? handleClientUpdate(
                                                      c,
                                                      filter === 1
                                                          ? 'Unwaitlist'
                                                          : filter === 2
                                                          ? 'Unarchive'
                                                          : ''
                                                  )
                                                : null
                                        "
                                    >
                                        {{
                                            filter === 1
                                                ? "Unwaitlist"
                                                : filter === 2
                                                ? "Unarchive"
                                                : ""
                                        }}
                                        patient
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <span class="p-3 font-italic" v-if="!pagination.total">No patient found.</span>
            </div>

            <paginator
                :pagination="pagination"
                @fetch="fetchOrganizationClients($event)"
            ></paginator>
        </div>

        <modal-component
            :id="'client-list-widget-modal-add'"
            :visible="addClientVisible"
            :title="`Add Client`"
            :size="`sm`"
            @close="resetModal()"
        >
            <!--ADD CLIENT INVITE-->
            <div>
                <div class="w-100 position-relative">
                    <input
                        type="text"
                        id="first-name-0"
                        class="form-control form-control my-1"
                        v-model="newClient.first_name"
                        placeholder="First Name"
                        required
                    />
                    <input
                        type="text"
                        id="last-name-0"
                        class="form-control form-control my-1"
                        v-model="newClient.last_name"
                        placeholder="Last Name"
                        required
                    />
                    <input
                        type="text"
                        id="parent-email-0"
                        class="form-control form-control my-1"
                        v-model="newClient.parent_email"
                        placeholder="Parent E-mail Address (optional)"
                    />
                </div>
                <transition name="simple-fade" mode="out-in">
                    <button
                        id="add-client"
                        class="btn btn-primary font-weight-bold text-uppercase text-white my-3"
                        @click="createClient()"
                    >
                        Add Client
                    </button>
                </transition>
            </div>

            <div v-if="errorMessage" class="alert alert-danger">
                <a href="#" class="close" data-dismiss="alert">&times;</a>
                <strong>Error!</strong> {{ errorMessage }}
            </div>
        </modal-component>

        <delete-confirmation
            :visible="deleteConfirmationVisible"
            :icon="'fa-archive'"
            :button-text="`Yes, ${deleteConfirmationButtonText} patient`"
            @confirm="updateClient(deletePayload.id)"
            @close="resetDelete()"
        >
            <template slot="title">
                {{ updateAction }} {{ helpers._get(deletePayload, "name", "patient") }}?
            </template>
            <template slot="description">
                <p>This action can be undone at any time.</p>
            </template>
        </delete-confirmation>
    </div>
</template>
<script>
import { permissions } from "../../plugins/permissions";
import { pagination } from "../../plugins/pagination";
import Tabs from "../ui/Tabs";
import ModalComponent from "../ui/ModalComponent";
import { helpers } from "../../plugins/helpers";
import { deleteConfirmation } from "../../plugins/deleteConfirmation";

export default {
    name: "PatientsMain",
    props: ["user", "organization"],
    components: {
        Tabs,
        ModalComponent,
    },
    mixins: [permissions, pagination, deleteConfirmation],
    data() {
        return {
            filter: 0, //Corresponds to which tab is selected
            filters: {
                archived: 0,
                waitlisted: 0,
            },
            updateAction: null,
            tabs: ["Current Patients", "Waitlisted Patients", "Archived Patients"],
            search: null,
            addClientVisible: false,
            newClient: {
                first_name: null,
                last_name: null,
                parent_email: null,
            },
            errorMessage: null,
            organizationClients: [],
        };
    },

    watch: {
        filter() {
            if (this.filter === 0) {
                this.filters.archived = 0;
                this.filters.waitlisted = 0;
            }

            if (this.filter === 1) {
                this.filters.archived = 0;
                this.filters.waitlisted = 1;
            }

            if (this.filter === 2) {
                this.filters.archived = 1;
                this.filters.waitlisted = 0;
            }

            this.fetchOrganizationClients();
        },
        organization() {
            if (this.organization) {
                this.initialize();
            }
        },
    },

    methods: {
        initialize() {
            this.fetchOrganizationClients();
        },

        updateFilter(event) {
            this.propSetFromChild(event);
        },

        showAddNewModal() {
            if (!this.canAddClient) return;
            this.addClientVisible = true;
        },

        resetModal() {
            this.addClientVisible = false;
            this.newClient = {
                first_name: null,
                last_name: null,
                parent_email: null,
            };
            this.errorMessage = null;
        },

        handleClientUpdate(client, action) {
            this.updateAction = action;
            this.deleteConfirmationButtonText = action;
            this.promptDelete(client);
        },

        validateClient(client) {
            return client.first_name && client.last_name;
        },

        createClient() {
            this.errorMessage = "";
            helpers.toggleSpinner("add-client");
            let payload = { ...this.newClient };
            if (!this.validateClient(payload)) {
                this.errorMessage =
                    "Please make sure that both first and last name fields are filled.";
                helpers.toggleSpinner("add-client");
                return;
            }
            payload.organization_id = this.organization.id;
            payload.user_id = this.user.id;
            axios
                .post("/api/patients", payload)
                .then(response => {
                    mixpanel.track("Patients - Add new client", {
                        "Parent Email": payload.parent_email ? true : false,
                    });
                    helpers.toggleSpinner("add-client");
                    this.fetchOrganizationClients();
                    this.resetModal();
                })
                .catch(error => {
                    console.error(error);
                    helpers.toggleSpinner("add-client");
                    if (error.response) {
                        if (error.response.status === 422) {
                            this.errorMessage =
                                error.response.status +
                                " - Please make sure that both first and last name fields are filled and that the client name is unique.";
                        } else {
                            this.errorMessage = error.response.status;
                        }
                    }
                });
        },

        fetchOrganizationClients(page) {
            let queryString = "?";
            queryString += `&page=${page || this.page}`;
            queryString += this.search ? `&q=${this.search}` : "";
            queryString += this.filters.archived ? `&is_archived=${this.filters.archived}` : "";
            queryString += this.filters.waitlisted
                ? `&is_waitlisted=${this.filters.waitlisted}`
                : "";

            axios
                .get(`/api/organizations/${this.organization.id}/patients${queryString}`)
                .then(r => {
                    this.organizationClients = r.data.data;
                    this.pagination = r.data.meta;
                });
        },

        getUpdatePayload() {
            if (this.updateAction === "Archive") {
                return { is_archived: 1 };
            }

            if (this.updateAction === "Unarchive") {
                return { is_archived: 0 };
            }

            if (this.updateAction === "Waitlist") {
                return { is_waitlisted: 1 };
            }

            if (this.updateAction === "Unwaitlist") {
                return { is_waitlisted: 0 };
            }
        },

        updateClient(id) {
            const payload = this.getUpdatePayload();

            axios
                .patch(`/api/patients/${id}`, payload)
                .then(r => {
                    this.fetchOrganizationClients();
                    this.updateAction = null;
                    this.resetDelete();
                })
                .catch(e => {
                    console.error(e);
                    this.updateAction = null;
                    this.resetDelete();
                });
        },
    },
};
</script>

<style scoped lang="scss">
.list-item {
    border: solid 1px #bfbfbf;
}
.list-item:not(:first-child) {
    border-top: none;
}
</style>
